import styled from 'styled-components';

const SearchBarHolder = styled.div`
   .search-bar {
		position: absolute;
		min-height:90px;
		padding: 20px;
		border-top: 2px solid rgba(25,25,25,.2);
		background-color: rgba(25, 25, 25, 0.9);	
		top: 75px;
		grid-area: header;
		width: 100%;
		z-index: -1;

		&.expand {
			transform: scaleY(1);
			transition: tranform 0.26s ease;
		}
		&.collapse {
			transform: scaleY(0);    
			transform-origin: top;
			transition: transform 0.26s ease;
		}

		.container {
		position: relative;
		max-width: 576px;
		margin: 0 auto;
			input {
			position: absolute;
			left: 0;
			font-size: 16px;
			font-weight: 700;
			width: 100%;
			margin-bottom: 1.6rem;
			padding: 12px;
			color: #606060;
			border: 1px solid #d1cdc1;
			border-radius: 5px;
			outline: 0;
			background-color: #fff;
			border-radius: 2em;
			text-align: left;

				@media only screen and (max-width: 920px) {
					text-align: left;
				}


				&:focus {
					text-align: left;
				}
			}
			button {
				position: absolute;
				right: 4px;
				top: 3px;
				border: solid 5px #d1cdc1;
				transition: all 0.3s ease-out;
				font-family: NexaX, Helvetica, Arial, sans-serif;
				font-size: 14px;
				line-height: 0.6;
				font-weight: bold;
				display: inline-block;
				height: auto;
				cursor: pointer;
				text-align: center;
				text-decoration: none;
				letter-spacing: 0.025em;
				border-radius: 4px;
				color: white;
				width: auto;
				min-width: 0;
				padding: 10px;
				background: #7a7652;
				max-height: 50px;
				margin: 15;
				border-radius: 2em;

				&:hover {
					background-color: #a69e87;
					border: solid 5px #a69e87;
				}
			}
		}


	}
	.sidebar-container{
		position: relative;
		margin: 0 auto;
			
		input {
			position: relative;
			left: 0;
			font-size: 12px;
			font-weight: 700;
			width: 100%;
			margin-top: 1.6rem;
			padding: 12px;
			color: #606060;
			border: 1px solid #d1cdc1;
			border-radius: 5px;
			outline: 0;
			background-color: #fff;
			border-radius: 2em;
			text-align: left;

			@media only screen and (max-width: 920px) {
				text-align: left;
			}
			@media only screen and (min-width: 1290px){
				font-size: 16px;
				font-weight: 700;
			}
			@media only screen and (min-width: 1170px) and (max-width: 1289px){
				font-size: 14px;
				font-weight: 700;
			}
			@media only screen and (max-width: 1050px){
				font-size: 16px;
				font-weight: 700;
			}

			&:focus {
				text-align: left;
			}
		}
		button {
			position: absolute;
			right: 4px;
			top: 29px;
			border: solid 3px #d1cdc1;
			transition: all 0.3s ease-out;
			font-family: NexaX, Helvetica, Arial, sans-serif;
			font-size: 14px;
			line-height: 0.6;
			font-weight: bold;
			display: inline-block;
			height: auto;
			cursor: pointer;
			text-align: center;
			text-decoration: none;
			letter-spacing: 0.025em;
			border-radius: 4px;
			color: white;
			width: auto;
			min-width: 0;
			padding: 10px;
			background: #7a7652;
			max-height: 50px;
			margin: 15;
			border-radius: 2em;

			&:hover {
				background-color: #a69e87;
				border: solid 3px #a69e87;
			}
			@media only screen and (min-width: 1290px){
				top: 28px;
				border: solid 5px #d1cdc1;
				&:hover {
					border: solid 5px #a69e87;
				}
			}
			@media only screen and (max-width: 1050px){
				top: 28px;
				border: solid 5px #d1cdc1;
			}
		}
		
	}
`;

export default SearchBarHolder;